import { Box, List, ListItemButton, ListItemText } from '@mui/material';
import { MuiRTL } from 'lib/MuiRTL';

const DockSidebarItem = ({ active, onClick }) => {
  return (
    <ListItemButton selected={active} onClick={onClick}>
      <ListItemText primary="بارانداز" />
    </ListItemButton>
  );
};

const ProductListSidebarItem = ({ active, onClick }) => {
  return (
    <ListItemButton selected={active} onClick={onClick}>
      <ListItemText primary="لیست محصول" />
    </ListItemButton>
  );
};

export const TransferWorkspaceSidebar = ({
  selectedSection,
  onSelectSidebarItem,
}) => {
  return (
    <Box sx={{ flex: 1, overflow: 'hidden' }}>
      <MuiRTL>
        <List
          dir="rtl"
          sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
          component="nav"
          aria-labelledby="nested-list-subheader"
        >
          <DockSidebarItem
            active={selectedSection.type === 'dock'}
            onClick={() => onSelectSidebarItem('dock')}
          />

          <ProductListSidebarItem
            active={selectedSection.type === 'productList'}
            onClick={() => onSelectSidebarItem('productList')}
          />
        </List>
      </MuiRTL>
    </Box>
  );
};
